import React, { createContext, useState, ReactNode } from "react";
import { ShopVariant } from "@texada/ui/src/helpers/generic";

interface PageContextType {
  variant?: ShopVariant;
  setVariant: (variant?: ShopVariant) => void;
}

export const PageContext = createContext<PageContextType>({
  variant: undefined,
  setVariant: () => {}
});

interface PageContentContextProviderProps {
  children: ReactNode;
}

export const PageContentContextProvider: React.FC<PageContentContextProviderProps> = ({ children }) => {
  const [variant, setVariant] = useState<ShopVariant | undefined>(undefined);

  return (
    <PageContext.Provider value={{ variant, setVariant }}>
      {children}
    </PageContext.Provider>
  );
};
